import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Checkbox = ({ onClick, title, className, value }) => {
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick(event);
    }
  };

  return (
    <div
      className={classNames('bmc-checkbox', className, {
        'bmc-checkbox--checked': value === true,
      })}
    >
      <div
        className="bmc-checkbox-switcher"
        role="checkbox"
        aria-checked={value === true}
        tabIndex={0}
        onClick={(event) => onClick(event)}
        onKeyDown={handleKeyDown}
        aria-label={title}
      />
      <div className="bmc-checkbox-title">{title}</div>
    </div>
  );
};

Checkbox.propTypes = {
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  value: PropTypes.bool.isRequired,
};

export default Checkbox;
